export default{ 
    BaseUrl : "http://ilogixtool.dev-hi.xyz/api/"
};

export const BaseUrl1 ={
    BaseUrl1:"https://ilogixtool.dev-hi.xyz/storage/profile/"
}
